import { EReportVisibility } from '@opengov/reporting-types';

import { composeStateMachine } from '../../../module';

import { reportFormActions } from '../../common/forms/reportForm/state';

import { ReportUpdateState } from '../records';

export const reportUpdateInitialState = ReportUpdateState();

export const reportUpdateState = composeStateMachine('REPORTS-REPORT-UPDATE', reportUpdateInitialState, (compose) => ({
  ...reportFormActions(compose, 'modifiedReport'),

  updateReportVisibility: compose.action((state, reportVisibility: EReportVisibility) => {
    return state.update('modifiedReport', (report) => report.set('visibility', reportVisibility));
  })
}));

export const {
  actions: reportUpdateActions,
  actionCreators: reportUpdateActionCreators,
  reducer: reportUpdateReducer,
  selector: reportUpdateSelector
} = reportUpdateState;
